import PageShell from "@/components/site/PageShell";
import BookingCTA from "@/components/home/BookingCTA";
import LazyImage from "@/components/site/LazyImage";
import { SITE } from "@/data/site";
import { POOL } from "@/data/content";

export default function Pool() {
  return (
    <PageShell testId="pool-page">
      {/* Cinematic drone video hero */}
      <section className="relative h-[82vh] min-h-[520px] w-full overflow-hidden bg-forest">
        <img src={SITE.poolImage} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
        <video
          className="absolute inset-0 h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          poster={SITE.poolImage}
          preload="auto"
        >
          <source src="/pool-drone.mp4" type="video/mp4" />
          <source src={SITE.poolVideo} type="video/webm" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-t from-forest/92 via-forest/30 to-forest/45" />
        <div className="absolute inset-x-0 bottom-0 mx-auto w-full max-w-[1400px] px-5 pb-14 md:px-10 md:pb-20">
          <p className="mb-4 text-sm uppercase tracking-widest-2 text-champagne md:text-base">Unwind · Infinity Pool</p>
          <h1 className="font-display text-5xl font-bold leading-[0.98] tracking-tight text-ivory [text-shadow:0_2px_24px_rgba(0,0,0,0.4)] sm:text-6xl md:text-7xl">
            <span className="block">Swimming Pool</span>
            <span className="block">&amp; Infinity Pool</span>
          </h1>
        </div>
      </section>

      <section className="bg-ivory py-12 md:py-16">
        <div className="mx-auto max-w-4xl px-5 text-center md:px-10">
          <h2 className="font-display text-4xl font-bold leading-tight tracking-tight text-forest sm:text-5xl md:text-6xl">
            A pool that spills into the Western Ghats
          </h2>
          <p className="mt-7 text-lg text-charcoal/70">{POOL.intro}</p>
        </div>

        {/* Couples & families */}
        <div className="mx-auto mt-16 grid max-w-[1400px] items-center gap-10 px-5 md:grid-cols-2 md:gap-16 md:px-10">
          <LazyImage src={POOL.images[0]} alt="Infinity pool with valley view" fit="cover" className="aspect-video rounded-2xl" />
          <div>
            <p className="mb-4 text-sm uppercase tracking-widest-2 text-brown md:text-base">For Everyone</p>
            <h3 className="font-display text-3xl font-bold text-forest md:text-4xl">Perfect for couples &amp; families</h3>
            <p className="mt-5 text-charcoal/70">{POOL.couplesFamilies}</p>
          </div>
        </div>

        {/* Sightseeing */}
        <div className="mx-auto mt-16 grid max-w-[1400px] items-center gap-10 px-5 md:grid-cols-2 md:gap-16 md:px-10">
          <div className="md:order-2">
            <LazyImage src={POOL.images[1]} alt="Poolside deck view" fit="cover" className="aspect-video rounded-2xl" />
          </div>
          <div className="md:order-1">
            <p className="mb-4 text-sm uppercase tracking-widest-2 text-brown md:text-base">The View</p>
            <h3 className="font-display text-3xl font-bold text-forest md:text-4xl">Western Ghats, from the water</h3>
            <p className="mt-5 text-charcoal/70">{POOL.sightseeing}</p>
          </div>
        </div>
      </section>

      <BookingCTA />
    </PageShell>
  );
}
